import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { DoubleRightOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { getAnnouncement } from '../../redux/actions/generalAnnoucement';
import announcementLogo from '../../assets/images/announcements.png';
import ModalComponent from '../../components/ui/ModalComponent';
import { showModal } from '../../redux/actions/ui';

const Announcement = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [list, setList] = useState([]);
  const [view, setView] = useState({});

  const getData = async() => {
    const data = await dispatch(getAnnouncement())
    setList(data);
  }
  useEffect(()=>{
    getData();
    // eslint-disable-next-line
  },[])

  const handleView = (item) => {
    dispatch(showModal());
    setShow(true);
    setView(item);
  }

  const hideModal = () => {
    setShow(false);
  }

  return (
    <div className="float-chat">
      {show && <ModalComponent onCloseModalSuccess={hideModal}>
        <div>
          <h4><strong>{view.title}</strong></h4>
          <h4>{view.description}</h4>
        </div>
      </ModalComponent>}
      <div className="announcement-container">
        <div className="heading-block">
          <img src={announcementLogo} alt="icon" width="30" height="30" />
          <h3>General Announcements</h3>
        </div>
        <div className="msgs-container custom-scroll">
          {list?.slice(0,3).map((item, i)=>(
            <div key={i}>
              <div className="msg">
                <div>
                  <strong>{dayjs(item.aired_on || item.created_on).format('MM/DD/YYYY')}</strong>{' - '}
                  <span className="title">{item.title}</span>
                  <br />
                  <span className="para">{item.description}</span>
                </div>
                <button onClick={() => handleView(item)}>View</button>
              </div>
              <hr />
            </div>
          ))}
          <Tooltip title="View More">
            <Button size="small" style={{float: 'right'}}>
              <Link to="/announcements"><DoubleRightOutlined style={{transform: 'rotate(90deg)'}}/></Link>
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
